
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/estate-agents/specialist-consultancy",
      function () {
        return require("private-next-pages/products/estate-agents/specialist-consultancy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/estate-agents/specialist-consultancy"])
      });
    }
  